import icon from '../../../../assets/logos/logo_invert.svg'

const NexoraIcon = () => {
    return (
        <img className='icon' src={icon} alt="" />
    )
}

export default NexoraIcon;